
function bar(target: any) {
    return target;
}

@bar
class Foo {
    
}